// 資源指派角色 (user_resource_assignment.role) 的中文名 —— **單一來源**。
//
// 2026-08-22 稽核: 同一個角色在畫面上有兩套名字, 而且中英混在同一列:
//   · sponsor_partner  「主辦合夥人」(TeamBadges / 離職精靈 / 專案詳情)
//                    vs「主理合夥人」(簽核路線 / 投資核決) —— 剛好 4:4
//   · fund_manager / fund_member / project_manager / project_member
//     在成員徽章與兩個 Members modal 直接顯示英文 `Fund Manager`…,
//     而同一列的 sponsor_partner 是中文 → 一列裡兩種語言。
//   · 基金詳情頁更誇張: 標籤寫「主辦合夥人」, 底下按鈕寫「指派 Sponsor Partner」。
//
// 取「主理合夥人 / 基金經理 / 專案經理」—— 不是隨便挑的: use-workflows.ts 的
// workflowAssignedRoleLabel() 早就是這一組, 而它是**簽核當下**顯示給簽核人看的
// 名字 (誰要核准這張單)。 決策畫面上的用詞優先。
//
// 加新角色請只改這裡; 三個呼叫端 (TeamBadges / FundMembersModal /
// ProjectMembersModal / OffboardingModal) 都讀這一份。
// ⚠ 刻意不標 `Record<string, string>` —— 那會讓 `.sponsor_partner` 的型別變成
//   `string | undefined` (noUncheckedIndexedAccess), 呼叫端全要加 `?? ''`。
//   用字面型別讓「已知的鍵」直接是 string; 動態查詢走下面的 rbacRoleLabel()。
export const RBAC_ROLE_LABEL = {
  sponsor_partner: '主理合夥人',
  fund_manager: '基金經理',
  fund_member: '基金成員',
  project_manager: '專案經理',
  project_member: '專案成員',
  // ⚠ 這裡的 administrator 是**工作流程的 assigned_role**, 不是能力的 role.code ——
  // 後端 workflows.ts 用 is_admin_or_owner() 判斷, 指的是管理員 (全公司權限),
  // **不是**資訊主管 (能力那邊的 administrator, 見 lib/capabilities.ts)。 同一個字兩個
  // 意思; 2026-09-19 差點照字面改成「資訊主管」。
  administrator: '管理員',
} satisfies Record<string, string>;

/** 對不上就原樣回傳 —— 不要為了「有中文」而猜。 */
export function rbacRoleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return (RBAC_ROLE_LABEL as Record<string, string>)[role] ?? role;
}
